/**
 * ClienteLocalRepository
 *
 * Abstrai o acesso aos clientes armazenados localmente via Electron IPC.
 */
import { getElectronAPI } from "@/plugins/desktop";

const ClienteLocalRepository = {
  _api() {
    return getElectronAPI();
  },

  async getAll(filtros = {}) {
    return this._api().clientes.getAll(filtros);
  },

  async getById(id) {
    return this._api().clientes.getById(id);
  },

  async search(termo) {
    return this._api().clientes.search(termo);
  },

  async salvarTodos(items) {
    return this._api().clientes.upsertMany(items);
  },

  async contar() {
    return this._api().clientes.contarClientes();
  },
};

export default ClienteLocalRepository;
